import React from "react";
import { Grid, Row, Col } from "react-bootstrap";
import MailingManagerTable from "./MailingManagerTable";

class MailingManager extends React.Component {
  render() {
    const { video } = this.props;
    return (
      <Grid>
        <Row>
          <Col md={12}>
            <MailingManagerTable video={video} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default MailingManager;



// WEBPACK FOOTER //
// ./src/components/pages/Mailing/MailingManager.js